export const VIAGEM_DESPESA_TIPOS = [
	{
		value: 'combustivel',
		label: 'Combustivel',
		extraFields: [
			{ key: 'posto', label: 'Posto', type: 'text' },
			{ key: 'litros', label: 'Litros', type: 'number' },
			{ key: 'valor_litro', label: 'Valor por litro', type: 'currency' },
			{ key: 'quilometragem', label: 'Odometro', type: 'number' },
		],
	},
	{
		value: 'arla',
		label: 'ARLA',
		extraFields: [
			{ key: 'posto', label: 'Posto', type: 'text' },
			{ key: 'litros', label: 'Litros', type: 'number' },
			{ key: 'valor_litro', label: 'Valor por litro', type: 'currency' },
		],
	},
	{
		value: 'pedagio',
		label: 'Pedagio',
		extraFields: [
			{ key: 'praca', label: 'Praca', type: 'text' },
			{ key: 'forma_pagamento', label: 'Forma de pagamento', type: 'text' },
			{ key: 'ticket', label: 'Ticket ou recibo', type: 'text' },
		],
	},
	{
		value: 'alimentacao',
		label: 'Alimentacao',
		extraFields: [
			{ key: 'estabelecimento', label: 'Estabelecimento', type: 'text' },
			{ key: 'cidade_uf', label: 'Cidade - UF', type: 'text' },
			{ key: 'refeicao', label: 'Tipo de refeicao', type: 'text' },
		],
	},
	{
		value: 'hospedagem',
		label: 'Hospedagem',
		extraFields: [
			{ key: 'local', label: 'Local', type: 'text' },
			{ key: 'quantidade_diarias', label: 'Qtd. de diarias', type: 'number' },
			{ key: 'hospede', label: 'Hospede', type: 'text' },
		],
	},
	{
		value: 'estacionamento_patio',
		label: 'Estacionamento / Patio',
		extraFields: [
			{ key: 'local', label: 'Local', type: 'text' },
			{ key: 'periodo', label: 'Periodo', type: 'text' },
			{ key: 'quantidade_diarias', label: 'Qtd. de diarias', type: 'number' },
		],
	},
	{
		value: 'carga_descarga_chapa',
		label: 'Carga e descarga / Chapa',
		extraFields: [
			{ key: 'prestador', label: 'Prestador', type: 'text' },
			{ key: 'local', label: 'Local', type: 'text' },
			{ key: 'tipo_servico', label: 'Tipo do servico', type: 'text' },
		],
	},
	{
		value: 'manutencao',
		label: 'Manutencao',
		extraFields: [
			{
				key: 'subtipo',
				label: 'Subtipo',
				type: 'select',
				items: ['Preventiva', 'Corretiva'],
			},
			{ key: 'fornecedor', label: 'Fornecedor', type: 'text' },
			{ key: 'servico', label: 'Servico realizado', type: 'text' },
		],
	},
	{
		value: 'pneus_borracharia',
		label: 'Pneus / Borracharia',
		extraFields: [
			{
				key: 'subtipo',
				label: 'Subtipo',
				type: 'select',
				items: ['Pneu', 'Borracharia', 'Rodizio'],
			},
			{ key: 'quantidade', label: 'Quantidade', type: 'number' },
			{ key: 'fornecedor', label: 'Fornecedor', type: 'text' },
		],
	},
	{
		value: 'lavagem',
		label: 'Lavagem',
		extraFields: [
			{ key: 'tipo_lavagem', label: 'Tipo de lavagem', type: 'text' },
			{ key: 'local', label: 'Local', type: 'text' },
		],
	},
	{
		value: 'balanca_pesagem',
		label: 'Balanca / Pesagem',
		extraFields: [
			{ key: 'local', label: 'Local', type: 'text' },
			{ key: 'peso_apurado', label: 'Peso apurado', type: 'number' },
		],
	},
	{
		value: 'travessia_balsa_ferry',
		label: 'Travessia / Balsa / Ferry',
		extraFields: [
			{ key: 'trecho', label: 'Trecho', type: 'text' },
			{ key: 'operador', label: 'Operador', type: 'text' },
		],
	},
	{
		value: 'diaria_adiantamento',
		label: 'Diaria / Adiantamento',
		extraFields: [
			{ key: 'favorecido', label: 'Favorecido', type: 'text' },
			{ key: 'forma_pagamento', label: 'Forma de pagamento', type: 'text' },
		],
	},
	{
		value: 'comissao_motorista',
		label: 'Comissao Motorista',
		extraFields: [],
	},
	{
		value: 'escolta_apoio_operacional',
		label: 'Escolta / Apoio operacional',
		extraFields: [
			{ key: 'fornecedor', label: 'Fornecedor', type: 'text' },
			{ key: 'trecho', label: 'Trecho', type: 'text' },
		],
	},
	{
		value: 'armazenagem_transbordo',
		label: 'Armazenagem / Transbordo',
		extraFields: [
			{ key: 'local', label: 'Local', type: 'text' },
			{ key: 'periodo', label: 'Periodo', type: 'text' },
		],
	},
	{
		value: 'multa_ocorrencia',
		label: 'Multa / Ocorrencia',
		extraFields: [
			{ key: 'motivo', label: 'Motivo', type: 'text' },
			{ key: 'orgao', label: 'Orgao ou responsavel', type: 'text' },
		],
	},
	{
		value: 'outros',
		label: 'Outros',
		extraFields: [
			{ key: 'categoria_livre', label: 'Categoria livre', type: 'text' },
			{ key: 'referencia', label: 'Referencia', type: 'text' },
		],
	},
];

export const VIAGEM_DESPESA_TIPOS_MAP = VIAGEM_DESPESA_TIPOS.reduce((accumulator, item) => {
	accumulator[item.value] = item;
	return accumulator;
}, {});

export function getViagemDespesaTipoMeta(value) {
	return VIAGEM_DESPESA_TIPOS_MAP[value] || null;
}